/* SOLSTICE — predictive-search.js (Predictive Search API, debounced) */
(function () {
  'use strict';
  const input = document.querySelector('[data-predictive-input]');
  const results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  let timer;
  let controller;

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(() => search(q), 220);
  });

  async function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    try {
      const url = `${window.Solstice.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,query,page,article&resources[limit]=6&section_id=predictive-search`;
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('#PredictiveSearchResults');
      results.innerHTML = inner ? inner.innerHTML : '';
    } catch (e) {
      if (e.name !== 'AbortError') console.error(e);
    }
  }
})();
